import React from 'react';

import { Link } from 'react-router-dom'
import { useEffect } from 'react';
import logoLarge from '../imgs/logoLarge.png';
import './page404.css';


export default function Page404() {

	useEffect(() => {
		document.title = "404 Page: RedPanda Fencing"
	}, []);	


	return <div style={{textAlign:"center"}}> 
	<h1>404 Page</h1>
	<h2>The URL you entered was incorrect.</h2>
	<Link to="/">Click on this link to return to the main page.</Link>
	
	
	
	</div> 
	



}